import Vue from "vue"
import Router from "vue-router"
import PDFGeneratorView from "@/views/PDFGeneratorView"
import PDFTrialReportView from "@/views/PDFTrialReportView"
import PDFSoilLabelView from "@/views/PDFSoilLabel"

const routes = [
  {
    path: "/",
    redirect: { name: "MapView" },
  },
  {
    path: "/map",
    name: "MapView",
    component: () => import('@/views/MapView'),
  },
  {
    path: "/boundary-editor",
    name: "boundary-editor",
    component: () => import('@/views/BoundaryEditorView'),
  },
  {
    path: "/fields",
    name: "fields",
    component: () => import('@/views/FieldList'),
  },
  {
    path: "/field-reports",
    name: "field-reports",
    component: () => import('@/views/FieldReportsList'),
  },
  {
    path: "/uploads",
    name: "uploads",
    component: () => import('@/views/Uploads'),
  },
  {
    path: "/settings/",
    component: () => import('@/views/EmptyRouterView'),
    children: [
      {
        path: "defaults",
        name: "defaults-list",
        component: () => import('@/views/DefaultsList'),
      },
      {
        path: "defaults/:defaultsTemplateId",
        name: "defaults-settings",
        component: () => import('@/views/DefaultsSettings'),
        props: true,
      },
    ],
  },
  {
    path: "/field/:fieldId",
    name: "field",
    component: () => import('@/views/FieldView'),
    props: true,
  },
  {
    path: "/dashboard-summary",
    name: "dashboard-summary",
    component: () => import('@/views/DashboardSummary'),
  },
  {
    path: "/seed-placements",
    name: "seed-placements-list",
    component: () => import('@/views/SeedPlacementsList'),
  },
  {
    path: "/seed-placements/:placementPlanId",
    name: "seed-placement-plan",
    component: () => import('@/views/SeedPlacementPlan'),
    props: true,
  },
  {
    path: "/seed-selector",
    name: "seed-selector",
    component: () => import('@/views/SeedSelectorView'),
  },
  {
    path: "/agt-performance",
    name: "agt-performance",
    component: () => import('@/views/AgtPerformance'),
  },
  {
    path: "/agts",
    name: "agts",
    component: () => import('@/views/AgtView'),
  },
  {
    path: "/arva-crop-designer",
    name: "arva-crop-designer",
    component: () => import('@/views/CropDesigner'),
  },
  {
    path: "/profit-and-loss",
    name: "profit-and-loss",
    component: () => import('@/views/ProfitAndLoss'),
  },
  {
    path: "/sustainability",
    name: "sustainability",
    component: () => import('@/views/Sustainability'),
  },
  {
    path: "/historical-profit-and-loss",
    name: "historical-profit-and-loss",
    component: () => import('@/views/HistoricalProfitAndLoss'),
  },
  {
    path: "/input-analytics",
    name: "input-analytics",
    component: () => import('@/views/InputAnalyticsView'),
  },
  {
    path: "/hybrid-placement",
    name: "hybrid-placement",
    component: () => import('@/views/HybridPlacementView'),
  },
  {
    path: "/field-imagery",
    name: "field-imagery",
    component: () => import('@/views/FieldImageryView'),
  },
  {
    path: "/field-satellite/:fieldId",
    name: "field-satellite",
    component: () => import('@/views/IndividualFieldImageryView'),
    props: true,
  },
  {
    path: "/order-imagery",
    name: "order-imagery",
    component: () => import('@/views/OrderImageryView'),
  },
  {
    path: "/imagery-list",
    name: "imagery-list",
    component: () => import('@/views/FieldImageryListView'),
  },
  {
    path: "/account",
    name: "account",
    component: () => import('@/views/AccountView'),
  },
  {
    path: "/superuser-admin",
    name: "superuser-admin",
    redirect: "/staff-admin"
  },
  {
    path: "/staff-admin",
    name: "staff-admin",
    component: () => import('@/views/StaffAdminView'),
  },
  {
    path: "/customer-admin",
    name: "customer-admin",
    component: () => import('@/views/CustomerAdminView'),
  },
  {
    path: "/data-sharing",
    name: "data-sharing",
    component: () => import('@/views/DataSharingView'),
  },
  {
    path: "/switch-orgs",
    name: "switch-orgs",
    component: () => import('@/views/SwitchOrgsView'),
  },
  {
    path: "/arva-pdf-generator/:reportHash",
    name: "arva-pdf-generator",
    component: PDFGeneratorView,
    props: true,
  },
  {
    path: "/arva-grower-pdf-generator/:reportHash",
    name: "arva-grower-pdf-generator",
    component: PDFGeneratorView,
    props: true,
  },
  {
    path: "/trial-title-page/:reportHash",
    name: "trial-title-page",
    component: PDFTrialReportView,
    props: true,
  },
  {
    path: "/trial-report-generator/:page/:reportHash",
    name: "trial-report-generator",
    component: PDFTrialReportView,
    props: true,
  },
  {
    path: "/trial-env-generator/:pageNum/:reportHash",
    name: "trial-env-generator",
    component: PDFTrialReportView,
    props: true,
  },
  {
    path: "/trial-rollup-generator/:reportHash",
    name: "trial-rollup-generator",
    component: () => import('@/views/PDFTrialReportView'),
    props: true,
  },
  {
    path: "/trial-microclimate/:reportHash",
    name: "trial-microclimate",
    component: PDFTrialReportView,
    props: true,
  },
  {
    path: "/login",
    name: "login",
    component: () => import('@/views/Login'),
  },
  {
    path: "/integrations/john-deere",
    name: "john-deere",
    component: () => import('@/views/ApiManagementCenter'),
    props: { initialTab: "john-deere-api" },
  },
  {
    path: "/data-spreadsheet",
    name: "data-spreadsheet",
    component: () => import('@/views/DataSpreadsheet'),
  },
  {
    path: "/data-spreadsheet/:fieldId",
    name: "data-spreadsheet-field",
    component: () => import('@/views/DataSpreadsheet'),
    props: true,
  },
  {
    path: "/zones-agt",
    name: "zones-agt",
    component: () => import('@/views/ZonesYield'),
    props: { isYield: false },
  },
  {
    path: "/zones-yield",
    name: "zones-yield",
    component: () => import('@/views/ZonesYield'),
    props: { isYield: true },
  },
  {
    path: "/order-trial-report",
    name: "order-trial-report",
    component: () => import('@/views/OrderTrialReport'),
  },
  {
    path: "/soil-sample-ui",
    name: "soil-sample-ui",
    component: () => import('@/views/SoilSampling'),
  },
  {
    path: "/enroll-manager",
    name: "enroll-manager",
    component: () => import('@/views/EnrollmentManagement'),
  },

  {
    path: "/enroll-manager",
    name: "enroll-manager-inset",
    component: () => import('@/views/EnrollmentManagement'),
  },
  {
    path: "/enroll-fields",
    name: "enroll-fields",
    component: () => import('@/views/EnrollFields'),
  },

  {
    path: "/enrollment-groups",
    name: "enrollment-groups",
    component: () => import('@/views/ContractGroups'),
  },
  {
    path: "/enrollment-groups/:id",
    name: "contract-group-detail",
    component: () => import('@/views/ContractGroupDetail')
  },

  {
    path: "/enrollment-groups/client/:clientId",
    name: "contract-group-client-detail",
    component: () => import('@/views/ContractGroupDetail')
  },

  {
    path: "/enroll-fields-inset",
    name: "enroll-fields-inset",
    component: () => import('@/views/EnrollFieldsInset'),
  },

  {
    path: "/soil-label-generator/:reportHash",
    name: "soil-label-generator",
    component: PDFSoilLabelView,
    props: true,
  },
  {
    path: "/historical-practices",
    name: "historical-practices",
    component: () => import('@/views/HistoricalPracticesLandingView'),
  },
  {
    path: "/historical-practices/harvest",
    name: "harvest-wizard",
    component: () => import('@/components/wizard/HarvestWizardTable'),
  },
  {
    path: "/historical-practices/irrigation",
    name: "irrigation-wizard",
    component: () => import('@/components/wizard/IrrigationWizardTable'),
  },
  {
    path: "/historical-practices/soil-sampling",
    name: "soil-sampling-wizard",
    component: () => import('@/components/wizard/SoilSamplingWizardTable'),
  },
  {
    path: "/historical-practices/aggregation",
    name: "aggregation-wizard",
    component: () => import('@/components/wizard/Aggregation'),
  },
  {
    path: "/evidencing",
    name: "evidencing",
    component: () => import('@/views/EvidencingGroupsOverview'),
  },
  {
    path: "/evidencing/dashboard",
    name: "evidencing-group-view",
    component: () => import('@/views/EvidencingGroupDashboard'),
  },
  {
    path: "/evidencing/create-group/",
    name: "create-evidencing-group",
    component: () => import('@/views/EvidencingGroupCreation'),
  },
  {
    path: "/evidencing/view/",
    name: "evidencing-group-view",
    component: () => import('@/views/EvidencingGroupTableView'),
  },
  {
    path: "/evidencing/validate/",
    name: "evidencing-group-validation-view",
    component: () => import('@/views/EvidencingGroupValidation'),
  },
  {
    path: "/ask-arva",
    name: "ask-arva",
    component: () => import('@/views/AskArvaView'),
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import('@/views/NotificationsView'),
  },
  {
    path: "/api-management-center",
    name: "api-management-center",
    component: () => import('@/views/ApiManagementCenter'),
    props: route => ({ initialTab: route.query.tab }),
  },
  {
    path: "/fsa-data-table",
    name: "fsa-data-table",
    component: () => import('@/views/FSADataTable'),
  },
  {
    path: "/buyer-inset-filter",
    name: "buyer-inset-filter",
    component: () => import('@/views/BuyerInsetFilter'),
  },
  {
    path: "/manage-aggregation-points",
    name: "manage-aggregation-points",
    component: () => import('@/views/AggregationMgmtView'),
  },
  {
    path: "/eic-explore",
    name: "eic explorer",
    component: () => import('@/views/EICExploreView')
  },
  {
    path: "/inventory-management",
    name: "inventory-management",
    component: () => import('@/views/CropPlannerInventory')
  },
  {
    path: "/crop-plans/:planId?",
    name: "crop-plans",
    component: () => import('@/views/CropPlanner'),
    props: true
  }
]

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes,
})

// Views read `prevRoute` to decide where "back" should go. Vue Router ignores
// unknown constructor options, so this has to be set on the instance -- passing
// it to the constructor left it `undefined` until the first guard ran, and every
// unguarded `prevRoute.path` read crashed in that window. Callers should still
// treat it as possibly null.
router.prevRoute = null

router.beforeEach((_, from, next) => {
  window.Intercom("update")
  router.prevRoute = from
  next()
})

export default router
